import styled from "styled-components";
import Colors from "../../themes/Colors";

const MapFiltersHolder = styled.div`
    .mobileOrderComponent {
        @media only screen and (max-width: 1200px) {
            text-align: left !important;
            margin-top: 30px !important;
        }
    }

    .filterActionsBlock {
        margin-left: auto;

        @media only screen and (max-width: 1000px) {
            margin-left: 0;
            margin-right: auto;
            margin-top: 8px;
        }
    }
`;

export default MapFiltersHolder;
